const twoStepAuthOptions = {
	sms: 0,
	voiceCall: 1,
	email: 2,
};

export { twoStepAuthOptions };
